/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { GlobalState } from '../actions';

export const userListSelector = (state: GlobalState) => { return state.userList; };

export const userListEntitiesSelector = (state: GlobalState) => userListSelector(state).users;
export const userListCountSelector = (state: GlobalState) => userListSelector(state).count;
export const userListSearchStringSelector = (state: GlobalState) => userListSelector(state).searchString;
export const userListCurrentPosSelector = (state: GlobalState) => userListSelector(state).startPos;
export const userListPageSizeSelector = (state: GlobalState) => userListSelector(state).slotSize;